import { Button, styled } from "@mui/material";

const CustomButton = styled(Button)(({ theme, variant }) => ({
  color: variant === "outlined" ? theme.palette.primary.main : theme.palette.common.white,
  backgroundColor: variant === "outlined" ? "transparent" : theme.palette.primary.main,
  border: variant === "outlined" ? `2px solid ${theme.palette.primary.light}` : "none",
  textTransform: "none",
  fontWeight:"600",
  padding:variant === "outlined" ?"8px 28px": "10px 30px",
  "&:hover": {
    backgroundColor: variant === "outlined" ? "transparent" : "#001833",
    border: variant === "outlined" ? `2px solid #001833` : "none",
    color: variant === "outlined" ? "#001833" : theme.palette.common.white,
  },
  "&.Mui-disabled": {
    color: variant === "outlined" ? theme.palette.action.disabled : theme.palette.common.white,
    backgroundColor: variant === "outlined" ? "transparent" : theme.palette.action.disabledBackground,
    border: variant === "outlined" ? `2px solid ${theme.palette.action.disabled}` : "none",
     boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
  },
}));

export default CustomButton;
